function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useMemo } from 'react';
import { useEntityRanks, useRequirementDifferences } from "../../../data";
import { isInternalRequirement } from "../../../data/requirements";
var filterRequirementsBasedOnTab = function filterRequirementsBasedOnTab(tab, requirements) {
  if (tab && tab.toLowerCase() === 'actions') {
    return requirements.filter(function (req) {
      return isInternalRequirement(req);
    });
  }
  if (tab && tab.toLowerCase() === 'applicant requirements') {
    return requirements.filter(function (req) {
      return !isInternalRequirement(req);
    });
  }
  return requirements;
};
var getEntityLevel = function getEntityLevel(entityLevelId, entityRankToIdMapping) {
  if (!entityRankToIdMapping[entityLevelId]) return undefined;
  return entityRankToIdMapping[entityLevelId].displayName;
};
export var useMassagedRequirementDifferences = function useMassagedRequirementDifferences(tab, applicationId) {
  var _useRequirementDiffer = useRequirementDifferences({
      applicationId: applicationId,
      extraFields: ['entityLevelId']
    }),
    requirementDifferences = _useRequirementDiffer.requirementDifferences,
    isLoadingRequirementDifferences = _useRequirementDiffer.isLoadingRequirementDifferences,
    isFetchingRequirementDifferences = _useRequirementDiffer.isFetchingRequirementDifferences;
  var _useEntityRanks = useEntityRanks(),
    entityRankToIdMapping = _useEntityRanks.entityRankToIdMapping,
    isLoadingEntityRanks = _useEntityRanks.isLoadingEntityRanks,
    isFetchingEntityRanks = _useEntityRanks.isFetchingEntityRanks;
  var filteredNew = useMemo(function () {
    if (Object.keys(requirementDifferences).length === 0 || !entityRankToIdMapping) return [];
    return filterRequirementsBasedOnTab(tab, requirementDifferences.filter(function (item) {
      return item.differenceType === 'new';
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        checked: item.applyAutomatically,
        entityLevel: getEntityLevel(item.entityLevelId, entityRankToIdMapping)
      });
    }));
  }, [tab, requirementDifferences, entityRankToIdMapping]);
  var filteredUnneeded = useMemo(function () {
    if (Object.keys(requirementDifferences).length === 0 || !entityRankToIdMapping) return [];
    return filterRequirementsBasedOnTab(tab, requirementDifferences.filter(function (item) {
      return item.differenceType === 'unneeded';
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        checked: item.applyAutomatically,
        entityLevel: getEntityLevel(item.entityLevelId, entityRankToIdMapping)
      });
    }));
  }, [tab, requirementDifferences, entityRankToIdMapping]);
  var filteredMod = useMemo(function () {
    if (Object.keys(requirementDifferences).length === 0 || !entityRankToIdMapping) return [];
    return filterRequirementsBasedOnTab(tab, requirementDifferences.filter(function (item) {
      return item.differenceType === 'different_from_template';
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        entityLevel: getEntityLevel(item.entityLevelId, entityRankToIdMapping)
      });
    }));
  }, [tab, requirementDifferences, entityRankToIdMapping]);
  return {
    filteredNew: filteredNew,
    filteredUnneeded: filteredUnneeded,
    filteredMod: filteredMod,
    isLoadingRequirementDifferences: isLoadingEntityRanks || isLoadingRequirementDifferences,
    isFetchingRequirementDifferences: isFetchingEntityRanks || isFetchingRequirementDifferences
  };
};